"use client"
import type { BadgeType } from '@/pages/courses/data/courses'
import { Baby, Users2, TrendingUp, Sparkles, Flame, Gem, Crown } from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

interface CourseBadgeProps {
  type: BadgeType
}

const badgeStyles: Record<NonNullable<BadgeType>, { bg: string; text: string; label: string; Icon: LucideIcon }> = {
  'for-kids': {
    bg: '#FFE5B4',
    text: '#F97316',
    label: 'For Kids',
    Icon: Baby
  },
  'for-women': {
    bg: '#FECDD3',
    text: '#BE123C',
    label: 'For Women',
    Icon: Users2
  },
  'popular': {
    bg: '#A8FF51',
    text: '#245E51',
    label: 'Popular',
    Icon: TrendingUp
  },
  'new': {
    bg: '#E0F2FE',
    text: '#0369A1',
    label: 'New',
    Icon: Sparkles
  },
  'sale': {
    bg: '#1F2937',
    text: '#FFFFFF',
    label: 'Sale',
    Icon: Flame
  },
  'premium': {
    bg: '#FEF3C7',
    text: '#D97706',
    label: 'Premium',
    Icon: Gem
  },
  'vip': {
    bg: '#7C3AED',
    text: '#FFFFFF',
    label: 'VIP',
    Icon: Crown
  }
}

export function CourseBadge({ type }: CourseBadgeProps) {
  if (!type) return null
  
  const style = badgeStyles[type]
  if (!style) return null
  
  const Icon = style.Icon
  
  return (
    <span
      className="inline-flex items-center gap-1 px-2.5 py-1 text-xs font-semibold tracking-wide rounded-full backdrop-blur-sm border shadow-sm"
      style={{
        backgroundColor: style.bg,
        color: style.text,
        borderColor: style.text + '40'
      }}
    >
      <Icon className="w-3 h-3" />
      <span>{style.label}</span>
    </span>
  )
}

// Multiple badges wrapper
interface CourseBadgesProps {
  badges?: BadgeType[]
}

export function CourseBadges({ badges }: CourseBadgesProps) {
  if (!badges || badges.length === 0) return null
  
  return (
    <div className="flex flex-wrap gap-1.5">
      {badges.map((badge, index) => (
        <CourseBadge key={`${badge}-${index}`} type={badge} />
      ))}
    </div>
  )
}
